module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAQCAYAAAAiYZ4HAAAAdklEQVQ4T+1SsQ2AMAyzeYCVcgsPwBtIfNVr4JU2rH2gQR2KqgqVGYmMju1YSSgS5ghYAgaNUkA6YKWT4N/I2SeJ6CVoAkbTszUh837B17fUyl/27kuXoEZOJAjqXhs9Pl8SJCI7PSrBSZGwKGABDM1YVEfldgF3QHZGUrCLGwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-username-placeholder.png
// module id = 178
// module chunks = 0